var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBtnLogout = function SvgBtnLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 116 44"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#btn-logout_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 26,
    x: 5,
    y: 5,
    fill: "url(#btn-logout_svg__b)",
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    width: 103,
    height: 31,
    x: 2.5,
    y: 2.5,
    stroke: "url(#btn-logout_svg__c)",
    strokeWidth: 5,
    rx: 12.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.62 20.629V22h-4.295v-1.371zm-3.726-7.16V22h-1.758v-8.531zm11.035 4.066v.404q0 .973-.264 1.747a3.8 3.8 0 0 1-.744 1.318q-.48.54-1.148.826a3.7 3.7 0 0 1-1.47.287 3.7 3.7 0 0 1-1.472-.287 3.3 3.3 0 0 1-1.148-.826 3.9 3.9 0 0 1-.756-1.319q-.264-.773-.264-1.745v-.405q0-.978.264-1.746a3.8 3.8 0 0 1 .744-1.318q.487-.545 1.149-.832a3.7 3.7 0 0 1 1.47-.287q.81 0 1.471.287.668.286 1.149.832.486.544.75 1.318.27.768.27 1.746m-1.775.404v-.416a5.2 5.2 0 0 0-.123-1.195 2.6 2.6 0 0 0-.364-.867 1.57 1.57 0 0 0-.586-.527 1.7 1.7 0 0 0-.79-.182q-.446 0-.792.182-.34.176-.58.527a2.7 2.7 0 0 0-.357.867 5.2 5.2 0 0 0-.123 1.195v.416q0 .674.123 1.196.123.514.363.873.24.351.586.533.345.182.791.182.445 0 .791-.182t.58-.533q.235-.358.358-.873.123-.521.123-1.196m9.482-.398v3.38q-.199.242-.615.522-.416.276-1.072.475-.657.2-1.588.2-.826 0-1.506-.27a3.25 3.25 0 0 1-1.172-.803 3.6 3.6 0 0 1-.75-1.29q-.263-.766-.263-1.751v-.533q0-.985.252-1.752.257-.768.732-1.295.474-.528 1.13-.803a3.7 3.7 0 0 1 1.46-.275q1.113 0 1.828.363.715.357 1.09.996.381.633.468 1.453h-1.705a2.2 2.2 0 0 0-.246-.756 1.27 1.27 0 0 0-.521-.504q-.335-.18-.867-.181-.44 0-.785.181a1.56 1.56 0 0 0-.575.522q-.234.345-.357.855a5 5 0 0 0-.123 1.184v.545q0 .668.129 1.183.13.51.38.862.258.345.633.521t.874.176q.416 0 .69-.07.282-.07.452-.17.175-.105.27-.2v-1.511h-1.606V17.54zm10.774-.006v.404q0 .973-.263 1.747a3.8 3.8 0 0 1-.744 1.318q-.48.54-1.149.826a3.7 3.7 0 0 1-1.47.287 3.7 3.7 0 0 1-1.471-.287 3.3 3.3 0 0 1-1.149-.826 3.9 3.9 0 0 1-.756-1.319q-.263-.773-.263-1.745v-.405q0-.978.263-1.746.264-.774.745-1.318.486-.545 1.148-.832a3.7 3.7 0 0 1 1.47-.287q.81 0 1.471.287.669.286 1.149.832.486.544.75 1.318.27.768.27 1.746m-1.775.404v-.416a5.2 5.2 0 0 0-.123-1.195 2.6 2.6 0 0 0-.363-.867 1.57 1.57 0 0 0-.586-.527 1.7 1.7 0 0 0-.791-.182q-.445 0-.791.182-.34.176-.58.527a2.7 2.7 0 0 0-.358.867 5.2 5.2 0 0 0-.123 1.195v.416q0 .674.123 1.196.123.514.364.873.24.351.586.533.345.182.79.182t.791-.182.58-.533q.235-.358.358-.873.123-.521.123-1.196m7.432-4.47h1.752v5.637q0 .983-.422 1.658-.416.674-1.154 1.013-.733.34-1.688.34t-1.699-.34a2.64 2.64 0 0 1-1.16-1.013q-.416-.674-.416-1.658v-5.637h1.758v5.637q0 .574.181.937.182.363.522.533.345.17.814.17.48 0 .815-.17.34-.169.515-.533.183-.364.182-.937zm6.694 0V22h-1.752v-8.531zm2.625 0v1.377h-6.961v-1.377z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M83.333 24v-1.333A2.667 2.667 0 0 0 80.667 20h-5.334a2.667 2.667 0 0 0-2.666 2.667V24M78 17.333A2.667 2.667 0 1 0 78 12a2.667 2.667 0 0 0 0 5.333M87.334 24v-1.334a2.67 2.67 0 0 0-2-2.58m-2.667-8a2.667 2.667 0 0 1 0 5.167"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "btn-logout_svg__b",
    x1: 54,
    x2: 54,
    y1: 5,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEE57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.693,
    stopColor: "#CB662D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#803F1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "btn-logout_svg__c",
    x1: 54,
    x2: 54,
    y1: 5,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461,
    stopColor: "#FFF2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE6D3E"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "btn-logout_svg__a",
    width: 116,
    height: 44,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10_14267"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10_14267",
    result: "shape"
  })))));
};
export default SvgBtnLogout;